import { useEffect } from 'react';
import queryString from 'query-string';
import axios from 'axios';
import React from "react";
import Layout from "../layouts";

const EmailConfirmation = () => {
  const queryParams = queryString.parse(window.location.search);
  const token = queryParams.confirmation;

  useEffect(() => {
    if (token) {
      axios.get("https://strapi1.arifinbrothers.com/api/auth/email-confirmation", {
        params: { confirmation: token }
      })
      .then(() => {
        alert("Email confirmed successfully!");
      })
      .catch((err) => {
        alert("Failed to confirm email.");
        console.error(err);
      });
    }
  }, [token]);

  return (
    <React.Fragment>
      <Layout>
        <h1>Email Confirmation</h1>
        <p>{token}</p>
        <p>Processing email confirmation...</p>
      </Layout>
    </React.Fragment>
  );
};

export default EmailConfirmation;